import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { DocumentTypeGeneralUse } from './documenttypegeneraluse';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap';
import { DocumenttypegeneraluseService } from './documenttypegeneraluse.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { LocalService } from '../../local.service';

declare var $: any;
@Component({
  selector: 'app-documenttypegeneraluse',
  templateUrl: './documenttypegeneraluse.component.html',
  styleUrls: ['./documenttypegeneraluse.component.css']
})
export class DocumenttypegeneraluseComponent implements OnInit {

  sendMenuId: number;
  sendPageName: string = 'DocumentTypeGeneralUse';
  //action rights
  _menuId: any;
  _actionRights: any;
  submitShow: boolean;
  readOnly: boolean; add: boolean; edit: boolean; delete: boolean;
  documenttypegeneraluseForm: FormGroup;
  documenttypegeneraluses: DocumentTypeGeneralUse[] = [];
  documenttypegeneralusesactive: DocumentTypeGeneralUse[] = [];
  documenttypegeneraluse: DocumentTypeGeneralUse;
  deleteResult: boolean
  postresult: boolean
  putDResult: boolean
  documenttypegeneraluseModalRef: BsModalRef;
  operation: string;
  userid: number;
  documenttypegeneraluseid: number;
  submitted = false;
  active: number;
  unamePattern: string;
  confmsg: string;
  p: number = 1; searchText: string;
  itemsPerPage: number = 10;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  showall: boolean = true;
  showallstatus: boolean = false;
  key: string = 'documenttypegeneraluse'; //set default
  reverse: boolean = false;

  constructor(
    private documenttypegeneraluseservice: DocumenttypegeneraluseService,
    private modalService: BsModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService, private dialogService: DialogService,
    private localService: LocalService) {
    //code to get relavent menu id
    if (this.router.getCurrentNavigation().extras.state != undefined) {
      // console.log(this.router.getCurrentNavigation().extras.state);
      localStorage.setItem('DocumentTypeGeneralUse_menuid', this.router.getCurrentNavigation().extras.state.menuid);
      localStorage.setItem('DocumentTypeGeneralUse_action', this.router.getCurrentNavigation().extras.state.action);
      this._menuId = this.router.getCurrentNavigation().extras.state.menuid;
      this.sendMenuId = this._menuId;
      this._actionRights = this.router.getCurrentNavigation().extras.state.action;
    }
    else {
      if (this._menuId == undefined)
        this._menuId = localStorage.getItem('DocumentTypeGeneralUse_menuid');
      this.sendMenuId = this._menuId;
      if (this._actionRights == undefined)
        this._actionRights = localStorage.getItem('DocumentTypeGeneralUse_action');
    }
  }

  ngOnInit() {
    this.checkIsMenuMapped();
    this.documenttypegeneraluseForm = this.formBuilder.group({
      documenttypegeneraluseid: [''],
      documenttypegeneraluse: ['', [Validators.required]],
      active: ['']
    });
    this.searchText = '';
    this.getAll();

    //for action rights
    this.readOnly = false;
    this.add = false;
    this.edit = false;
    this.delete = false;
    this.submitShow = false;
    this.getActionRightsList();
  }

  getactiveinactive(showallp) {
    this.documenttypegeneralusesactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.documenttypegeneraluses.forEach(data => {
        if (data.active == 1) {
          this.documenttypegeneralusesactive.push(data);
        }
      });
      this.documenttypegeneraluses = [];
      this.documenttypegeneraluses = this.documenttypegeneralusesactive;
    }
    else {
      this.showall = true;
      this.documenttypegeneraluses = [];
      this.getAll();
    }
  }

  checkIsMenuMapped()
  {
    const arrays = this.localService.getJsonValue("menulist");
    const notauthorized = this.localService.getJsonValue("notauthorizedgeneraluse");
    let data = arrays.find(ob => ob['name'] === 'Document Type General Use');
    if((data == undefined || data =='') && (notauthorized!=="true"))
    {
      this.localService.setJsonValue("notauthorizedgeneraluse","true");
      this.toastr.error('You are not authorized to access this page.');
      this.router.navigate(["home"]);
    }
    if(notauthorized=="true"){
      this.localService.setJsonValue("notauthorizedgeneraluse",null);
      this.router.navigate(["home"]);      
    }
  }

  //assigning value from menu rights button
  getActionRightsList() {
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
  }

  clearForm() {
    //for action rights
    if (this.add == true)
      this.submitShow = true;
    else
      this.submitShow = false;
    this.documenttypegeneraluseModalRef.hide();
  }

  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  getAll() {
    this.documenttypegeneraluses = [];
    this.documenttypegeneralusesactive = [];
    this.documenttypegeneraluseservice.Get().subscribe(res => {
      this.documenttypegeneraluses = res;
      if (this.showallstatus == true) {
        this.documenttypegeneraluses.forEach(data => {
          if (data.active == 1) {
            this.documenttypegeneralusesactive.push(data);
          }
        });
        this.documenttypegeneraluses = [];
        this.documenttypegeneraluses = this.documenttypegeneralusesactive;
      }
    }, error => { this.toastr.error('Error while getting data'); });

  }

  get g() { return this.documenttypegeneraluseForm.controls; }

  Post(documenttypegeneraluse: DocumentTypeGeneralUse) {

    this.submitted = true;
    // stop here if form is invalid
    //if (this.documenttypegeneraluseForm.invalid) {
    //  console.log(this.g);
    //  console.log(this.documenttypegeneraluseForm.errors);
    //}

    if ((documenttypegeneraluse.documenttypegeneraluse.trim() == undefined) || (documenttypegeneraluse.documenttypegeneraluse.trim() == '')) {
      this.toastr.error('DocumentTypeGeneralUse should not be empty');
      return;
    }

    var msg = null;

    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    documenttypegeneraluse.documenttypegeneraluse = documenttypegeneraluse.documenttypegeneraluse.trim();
    if (this.operation == 'add') {

      documenttypegeneraluse.createdby = this.userid;
      msg = "Record Added Successfully";
      this.documenttypegeneraluseservice.Post(documenttypegeneraluse).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            if (res.body != 0) {
              this.documenttypegeneraluseModalRef.hide();
              this.getAll();
              this.toastr.success('Data added successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }
    else if (this.operation = 'update') {
      this.submitShow = true;
      documenttypegeneraluse.modifiedby = this.userid;
      msg = "Record updated successfully";
      this.documenttypegeneraluseservice.Put(documenttypegeneraluse).subscribe(res => {
        if (res.status == 200) {
          if (res != undefined) {
            ;
            if (res.body != 0) {
              this.documenttypegeneraluseModalRef.hide();
              this.getAll();
              this.toastr.success('Data updated successfully');
              this.clearForm();
            }
            else { this.toastr.warning('Record already exists.'); }
          }
        };
      },
        error => {
          this.toastr.error("Error while doing the operation");
          this.postresult = false
        })
    }

    //console.log(this.documenttypegeneraluseForm.value);


  }

  ChangeActive(e) {
    if (e.currentTarget.checked) {
      this.documenttypegeneraluseForm.value.active = 1;
    } else {
      this.documenttypegeneraluseForm.value.active = 0
    }
  }

  OpenConfirmTemplate(documenttypegeneraluse, template: TemplateRef<any>) {
    if (documenttypegeneraluse.active == 0) {
      this.confmsg = "activate";
    }
    else
      this.confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + this.confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.documenttypegeneraluse = documenttypegeneraluse;

          this.Delete();

        }

      });

  }

  Delete() {
    var msg;
    if (this.documenttypegeneraluse.active == 0) {
      this.documenttypegeneraluse.active = 1
      msg = "Record activated successfully"
    }
    else {
      this.documenttypegeneraluse.active = 0;
      msg = "Record deactivated successfully"
    }
    //this.userid = +localStorage.getItem("userid");
    this.userid = +this.localService.getJsonValue("userid");
    this.documenttypegeneraluse.modifiedby = this.userid;
    this.documenttypegeneraluseservice.Delete(this.documenttypegeneraluse).subscribe(res => {
      this.toastr.success(msg);
      this.getAll();
    },
      error => { this.deleteResult = false })

  }

  hidePopup() {
    this.documenttypegeneraluseModalRef.hide();
  }

  openDocumentTypeGeneralUseModal(template: TemplateRef<any>, type, documenttypegeneraluse?: DocumentTypeGeneralUse) {

    this.operation = type

    if (type == 'update') {
      this.documenttypegeneraluseForm.controls['documenttypegeneraluseid'].setValue(documenttypegeneraluse.documenttypegeneraluseid);
      this.documenttypegeneraluseForm.controls['documenttypegeneraluse'].setValue(documenttypegeneraluse.documenttypegeneraluse);
      this.documenttypegeneraluseForm.controls['active'].setValue(documenttypegeneraluse.active);
      this.documenttypegeneraluse = documenttypegeneraluse;
    }
    if (type == 'add') {
      this.documenttypegeneraluseForm.controls['documenttypegeneraluseid'].setValue(0);
      this.documenttypegeneraluseForm.controls['documenttypegeneraluse'].setValue('');
      this.documenttypegeneraluseForm.controls['active'].setValue(1);
    }
    this.documenttypegeneraluseModalRef = this.modalService.show(template, this.config);

    const aa = document.getElementsByClassName('modal-content');
    aa[0].classList.remove("modal-content");

  }

}
